import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'

import { PERMISSIONS } from '../../common/constants'

import { PermissionRedirect } from '../../account/components/sections'

import { MenuDataPage } from './pages'

const ReportsRouter = () => (
  <>
    <Routes>
      <Route
        index
        element={
          <PermissionRedirect permissions={PERMISSIONS.MENU.GET_DATA}>
            <MenuDataPage />
          </PermissionRedirect>
        }
      />
    </Routes>

    <Outlet />
  </>
)

export default ReportsRouter
